class GlobalConfig {
    constructor() {
        this.API = {
            AUTH_API: '',
            CORE_API: '',
            MEDIA_API: '',
            ANALYTICS_API: '',
        };
        this.APP_ENV = '';
        this.CDN_URL = {
            SHARED_URL: '',
            EDITOR_URL: '',
            LIHP_URL: '',
        };
        this.IMAGE_KIT = {
            IMAGEKIT_PUBLIC_KEY: '',
            IMAGEKIT_URL_ENDPOINT: '',
        };
        this.hostUrl = '';
        this.createPageHostUrl = '';
        this.socialLinks = {};
    }
    get SiteConfig() {
        return this.siteConfig;
    }
    set SiteConfig(config) {
        this.siteConfig = config;
    }
    get HOST_URL() {
        return this.hostUrl;
    }
    set HOST_URL(url) {
        this.hostUrl = url;
    }
    get CREATE_PAGE_HOST_URL() {
        return this.createPageHostUrl;
    }
    set CREATE_PAGE_HOST_URL(url) {
        this.createPageHostUrl = url;
    }
    get api() {
        return this.API;
    }
    set api(payload) {
        this.API = payload;
    }
    get cdn() {
        return this.CDN_URL;
    }
    set cdn(payload) {
        this.CDN_URL = payload;
    }
    get appENV() {
        return this.APP_ENV;
    }
    set appENV(env) {
        this.APP_ENV = env;
    }
    set SocialLinks(links) {
        this.socialLinks = links;
    }
    get social() {
        return {
            links: this.socialLinks,
            icons: {
                twitter: `${this.CDN_URL.SHARED_URL}/social-icons/icon-twitter.svg`,
                facebook: `${this.CDN_URL.SHARED_URL}/social-icons/icon-fb.svg`,
                instagram: `${this.CDN_URL.SHARED_URL}/social-icons/icon-snap.svg`,
                youtube: `${this.CDN_URL.SHARED_URL}/social-icons/icon-yt.svg`,
                linkedin: `${this.CDN_URL.SHARED_URL}/social-icons/icon-in.svg`,
                pinterest: `${this.CDN_URL.SHARED_URL}/social-icons/icon-pin.svg`,
            },
        };
    }
    get APP_PROMO_URL() {
        return `${this.cdn.SHARED_URL}/app-promo`;
    }
    get HEADER_ICON_URL() {
        return `${this.cdn.SHARED_URL}/header-icons`;
    }
    get APP_PROMO() {
        return {
            title: 'Edit on the go',
            firstLine: 'Edit on the go',
            secondLine: 'Mobile editor by InVideo',
            description: 'The easiest way to make videos on your phone and tablet',
            icon: {
                url: `${this.HEADER_ICON_URL}/angle-right-white.svg`,
                alt: 'angle right',
                width: '4px',
                height: '7px',
            },
            backgroundGradientClass: 'iv-gradient-raspberry-deep-blue-blue',
            appImage: `${this.APP_PROMO_URL}/filmr-mobile.png`,
        };
    }
    get AI_APP_PROMO() {
        return {
            title: 'Edit on the go',
            firstLine: 'Available on',
            secondLine: 'iOS & Android',
            description: '',
            icon: {
                url: `${this.HEADER_ICON_URL}/angle-right-white.svg`,
                alt: 'angle right',
                width: '4px',
                height: '7px',
            },
            backgroundGradientClass: 'iv-gradient-blue',
            appImage: `${this.APP_PROMO_URL}/ai_frame_2x.png`,
        };
    }
    get APP_PROMO_LINKS() {
        return {
            desktop: {
                iOS: {
                    imageURL: `${this.APP_PROMO_URL}/apple-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/apple-store-transparent.svg`,
                    url: 'https://apps.apple.com/in/app/filmr-pro-video-editor/id1171358257',
                    text: 'Get it on App store',
                },
                Android: {
                    imageURL: `${this.APP_PROMO_URL}/play-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/play-store-transparent.svg`,
                    url: 'https://play.google.com/store/apps/details?id=com.filmrapp.videoeditor',
                    text: 'Get it on Play store',
                },
            },
            mobile: {
                iOS: {
                    imageURL: `${this.APP_PROMO_URL}/apple-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/apple-store-transparent.svg`,
                    url: 'https://apps.apple.com/in/app/filmr-pro-video-editor/id1171358257',
                    text: 'Get it on App store',
                },
                Android: {
                    imageURL: `${this.APP_PROMO_URL}/play-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/play-store-transparent.svg`,
                    url: 'https://play.google.com/store/apps/details?id=com.filmrapp.videoeditor',
                    text: 'Get it on Play store',
                },
            },
        };
    }
    get APP_AI_PROMO_LINKS() {
        return {
            desktop: {
                iOS: {
                    imageURL: `${this.APP_PROMO_URL}/apple-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/apple-store-transparent.svg`,
                    url: 'https://apps.apple.com/app/apple-store/id6471394316?pt=126720867&ct=invideo-header&mt=8',
                    text: 'Get it on App store',
                },
                Android: {
                    imageURL: `${this.APP_PROMO_URL}/play-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/play-store-transparent.svg`,
                    url: 'https://play.google.com/store/apps/details?id=io.invideo.ai',
                    text: 'Get it on Play store',
                },
            },
            mobile: {
                iOS: {
                    imageURL: `${this.APP_PROMO_URL}/apple-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/apple-store-transparent.svg`,
                    url: 'https://invideo-ai.app.link/hp-banner',
                    text: 'Get it on App store',
                },
                Android: {
                    imageURL: `${this.APP_PROMO_URL}/play-store.svg`,
                    transparentImageURL: `${this.APP_PROMO_URL}/play-store-transparent.svg`,
                    url: 'https://invideo-ai.app.link/hp-banner',
                    text: 'Get it on Play store',
                },
            },
        };
    }
    set imageKit(payload) {
        this.IMAGE_KIT = payload;
    }
    get imageKit() {
        return this.IMAGE_KIT;
    }
}
export default new GlobalConfig();
